export const tagMocks = {
  name: 'tag',
  id: '1',
  tag: 'tag',
};
